import {
  IBranchForecast,
  IBranchShipment,
  ICartItem,
  IOrder,
  IStatusableOrder,
} from './orders'
import { IProduct, IBranchesProduct, IProductKind } from './products'

export const STORAGE_USER_TOKEN_KEY = 'userToken'
export const STORAGE_USER_KEY = 'user'

export type UserRole =
  | 'internal'
  | 'manager'
  | 'technician'
  | 'planner'
  | 'checkout_manager'
  | 'general_manager'
  | 'general_and_checkout_manager'
  | ''

export interface IUser {
  id: number
  name: string
  avatar?: string
  role: UserRole
  email?: string
  lastSignInAt?: string
  branches?: IBranch[]
  divisions?: IDivision[]
  teams?: ITeam[]
  status?: string
  resetPasswordSentAt?: string
  isRemovable?: boolean
  isMovable?: boolean
  account?: IAccount
  availableAccounts?: IAccount[]
  password?: string
  generalManager?: boolean
  checkoutManager?: boolean
  updatedAt?: string
  emailInboundInventoryApproval?: boolean
  emailLowStockWarning?: boolean
  emailOrderApprovalRequest?: boolean
  emailReplenishmentPlanReminder?: boolean
  enableReports?: boolean
  emailLocationInventory?: boolean
  binCount?: boolean
  termsAcceptedAt?: string | null
  impersonating?: boolean
  clonedUsers?: IUser[]
  sanaPasswordSyncedAt?: string | null
  sanaPasswordSyncError?: string | null
}

export interface IBranch {
  id: number
  name: string
  navId?: string
  plannedProductsCount?: number
  shipmentApproveFlow?: boolean
  address?: string
  address2?: string
  zip?: string
  city?: string
  state?: string
  products?: IProduct[]
  actualOrders?: IStatusableOrder[]
  forecasts?: IBranchForecast[]
  shipments?: IBranchShipment[]
  showTechPrice?: boolean
  truckInventoryFeature?: boolean
  binInventoryFeature?: boolean
  invoiceMappingRow?: string
  sanaLoginManager?: IUser
  lastSync?: IAccountSync
  shipToCode?: string
  replenishmentFile?: string
  cartItems?: ICartItem[]
  suggestedCartItems?: ICartItem[]
  purchaseOrderNumber?: string
}
export type IPlannedBranch = IBranch & {
  forecasts: IBranchForecast[]
  shipments: IBranchShipment[]
  products?: IProduct[]
}

export interface IAccount {
  id: number
  name: string
  logo?: string
  branches: IBranch[]
  products?: IProduct[]
  productsCheckoutable?: IProduct[]
  productsOrderable?: IProduct[]
  accountProducts?: IProduct[]
  catalog?: IProduct[]
  users?: IUser[]
  managers?: IUser[]
  divisions?: IDivision[]
  branchesProduct?: IBranchesProduct[]
  navAccountId?: string
  navSalesCode?: string
  lastSync?: IAccountSync
  orderApproveFlow: boolean
  live?: boolean
  ordersEnabled: boolean
  erpCatalogs: string[]
  erpOrders?: string
  truckInventoryFeature: boolean
  binInventoryFeature: boolean
  hasInvoices?: boolean
  // The customer's own decision about ForeSight Intelligence. Opted out means
  // no question from anyone on this account reaches Anthropic.
  assistantOptOut?: boolean
  assistantOptOutReason?: string | null
  assistantOptedOutAt?: string | null
}

export interface IAccountSync {
  id: number
  status: 'scheduled' | 'running' | 'finished' | 'failed'
  finishedAt: string
  syncErrors: {
    [key: string]: string
  }
  startedAt: string
  createdAt: string
}

export interface IDivision {
  id: number
  name: string
  managers?: IUser[]
  technicians?: IUser[]
  products?: IProduct[]
  branchId: number
}

export interface ITeam {
  id: number
  name: string
  managers?: IUser[]
  technicians?: IUser[]
  branchId: number
}

export interface ICheckout {
  name: number
  asap: boolean
  cost: number
  createdAt: string
  updatedAt: string
  id: number
  totalItems: number
  totalUnits: number
}
